<template>
  <div class="user-status">
    <a-dropdown class="user-name">
      <div class="statusName">
        <div class="user-status-dropdown-link">{{ dispatchStateName }}
          <a-icon type="caret-down" />
        </div>
      </div>
      <a-menu slot="overlay">
        <a-menu-item>
          <div @click="handleStateCommand('1')">上班</div>
        </a-menu-item>
        <a-menu-item>
          <div @click="handleStateCommand('2')">下班</div>
        </a-menu-item>
        <a-menu-item>
          <div @click="handleStateCommand('3')">忙碌</div>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>

</template>

<script>
export default {
  data() {
    return {
      dispatchStateName: '下班',
    };
  },

  mounted() {
    this.sendRequestToGetState();
  },
  methods: {
    // 初始化页面时获取用户状态(1上班，2下班，3忙碌)的请求
    sendRequestToGetState() {
      // const { user } = JSON.parse(window.localStorage.userInfo);
      // const { userCode } = user;
      this.$http
        .post(this.$api.querySelfState, {})
        .then((res) => {
          const status = res.state;
          if (status === 1) {
            this.dispatchStateName = '上班';
          }
          if (status === 2) {
            this.dispatchStateName = '下班';
          }
          if (status === 3) {
            this.dispatchStateName = '忙碌';
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击用户状态的操作
    handleStateCommand(command) {
      this.sendRequestToChangeState(command);
    },
    // 发送切换用户状态(1上班，2下班，3忙碌)的请求
    sendRequestToChangeState(command) {
      // const { user } = JSON.parse(window.localStorage.userInfo);
      // const { userCode } = user;
      this.$http
        .post(this.$api.switchState, {
          state: command,
        })
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          if (command === '1') {
            this.dispatchStateName = '上班';
          }
          if (command === '2') {
            this.dispatchStateName = '下班';
          }
          if (command === '3') {
            this.dispatchStateName = '忙碌';
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
.user-status {
  border-radius: 20px;
  background-color: white;
  width: 75px;
  height: 30px;
  line-height: 30px;
  display: flex;
  align-items: center;
}

.user-status-dropdown-link {
  color: rgba(54, 115, 255, 100);
  cursor: pointer;
}

.user-name {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
